export const BungaChartData = [
    {
        "Bulan": "1",
        "Tahun": 2022,
        "MonthName": "Jan",
        "TitleName" : "Giro",
        "Nilai": "1451608041859.00",
        "Grup": 1
    },
    {
        "Bulan": "2",
        "Tahun": 2022,
        "MonthName": "Feb",
        "TitleName" : "Giro",
        "Nilai": "1072101990324.00",
        "Grup": 1
    },
    {
        "Bulan": "3",
        "Tahun": 2022,
        "MonthName": "Mar",
        "TitleName" : "Giro",
        "Nilai": "1549373085632.00",
        "Grup": 1
    },
    {
        "Bulan": "4",
        "Tahun": 2022,
        "MonthName": "Apr",
        "TitleName" : "Giro",
        "Nilai": "1457762514407.00",
        "Grup": 1
    },
    {
        "Bulan": "5",
        "Tahun": 2022,
        "MonthName": "May",
        "TitleName" : "Giro",
        "Nilai": "1670325426053.00",
        "Grup": 1
    },
    {
        "Bulan": "6",
        "Tahun": 2022,
        "MonthName": "Jun",
        "TitleName" : "Giro",
        "Nilai": "1565291309627.00",
        "Grup": 1
    },
    {
        "Bulan": "7",
        "Tahun": 2022,
        "MonthName": "Jul",
        "TitleName" : "Giro",
        "Nilai": "1649147480516.00",
        "Grup": 1
    },
    {
        "Bulan": "8",
        "Tahun": 2022,
        "MonthName": "Aug",
        "TitleName" : "Giro",
        "Nilai": "1757941086827.00",
        "Grup": 1
    },
    {
        "Bulan": "9",
        "Tahun": 2022,
        "MonthName": "Sep",
        "TitleName" : "Giro",
        "Nilai": "1914709105431.00",
        "Grup": 1
    },
    {
        "Bulan": "10",
        "Tahun": 2022,
        "MonthName": "Oct",
        "TitleName" : "Giro",
        "Nilai": "2005701216584.00",
        "Grup": 1
    },
    {
        "Bulan": "11",
        "Tahun": 2022,
        "MonthName": "Nov",
        "TitleName" : "Giro",
        "Nilai": "1949213422331.00",
        "Grup": 1
    },
    {
        "Bulan": "12",
        "Tahun": 2022,
        "MonthName": "Dec",
        "TitleName" : "Giro",
        "Nilai": "2131076373409.00",
        "Grup": 1
    },

    //
    {
        "Bulan": "1",
        "Tahun": 2022,
        "MonthName": "Jan",
        "TitleName" : "NotPool",
        "Nilai": "1151608041859.00",
        "Grup": 1
    },
    {
        "Bulan": "2",
        "Tahun": 2022,
        "MonthName": "Feb",
        "TitleName" : "NotPool",
        "Nilai": "972101990324.00",
        "Grup": 1
    },
    {
        "Bulan": "3",
        "Tahun": 2022,
        "MonthName": "Mar",
        "TitleName" : "NotPool",
        "Nilai": "1249373085632.00",
        "Grup": 1
    },
    {
        "Bulan": "4",
        "Tahun": 2022,
        "MonthName": "Apr",
        "TitleName" : "NotPool",
        "Nilai": "1857762514407.00",
        "Grup": 1
    },
    {
        "Bulan": "5",
        "Tahun": 2022,
        "MonthName": "May",
        "TitleName" : "NotPool",
        "Nilai": "1170325426053.00",
        "Grup": 1
    },
    {
        "Bulan": "6",
        "Tahun": 2022,
        "MonthName": "Jun",
        "TitleName" : "NotPool",
        "Nilai": "1265291309627.00",
        "Grup": 1
    },
    {
        "Bulan": "7",
        "Tahun": 2022,
        "MonthName": "Jul",
        "TitleName" : "NotPool",
        "Nilai": "1349147480516.00",
        "Grup": 1
    },
    {
        "Bulan": "8",
        "Tahun": 2022,
        "MonthName": "Aug",
        "TitleName" : "NotPool",
        "Nilai": "1457941086827.00",
        "Grup": 1
    },
    {
        "Bulan": "9",
        "Tahun": 2022,
        "MonthName": "Sep",
        "TitleName" : "NotPool",
        "Nilai": "1614709105431.00",
        "Grup": 1
    },
    {
        "Bulan": "10",
        "Tahun": 2022,
        "MonthName": "Oct",
        "TitleName" : "NotPool",
        "Nilai": "1705701216584.00",
        "Grup": 1
    },
    {
        "Bulan": "11",
        "Tahun": 2022,
        "MonthName": "Nov",
        "TitleName" : "NotPool",
        "Nilai": "1349213422331.00",
        "Grup": 1
    },
    {
        "Bulan": "12",
        "Tahun": 2022,
        "MonthName": "Dec",
        "TitleName" : "NotPool",
        "Nilai": "2031076373409.00",
        "Grup": 1
    },

    //
    {
        "Bulan": "1",
        "Tahun": 2022,
        "MonthName": "Jan",
        "TitleName" : "Deposito",
        "Nilai": "951608041859.00",
        "Grup": 1
    },
    {
        "Bulan": "2",
        "Tahun": 2022,
        "MonthName": "Feb",
        "TitleName" : "Deposito",
        "Nilai": "1272101990324.00",
        "Grup": 1
    },
    {
        "Bulan": "3",
        "Tahun": 2022,
        "MonthName": "Mar",
        "TitleName" : "Deposito",
        "Nilai": "1749373085632.00",
        "Grup": 1
    },
    {
        "Bulan": "4",
        "Tahun": 2022,
        "MonthName": "Apr",
        "TitleName" : "Deposito",
        "Nilai": "1657762514407.00",
        "Grup": 1
    },
    {
        "Bulan": "5",
        "Tahun": 2022,
        "MonthName": "May",
        "TitleName" : "Deposito",
        "Nilai": "1370325426053.00",
        "Grup": 1
    },
    {
        "Bulan": "6",
        "Tahun": 2022,
        "MonthName": "Jun",
        "TitleName" : "Deposito",
        "Nilai": "1865291309627.00",
        "Grup": 1
    },
    {
        "Bulan": "7",
        "Tahun": 2022,
        "MonthName": "Jul",
        "TitleName" : "Deposito",
        "Nilai": "1949147480516.00",
        "Grup": 1
    },
    {
        "Bulan": "8",
        "Tahun": 2022,
        "MonthName": "Aug",
        "TitleName" : "Deposito",
        "Nilai": "1557941086827.00",
        "Grup": 1
    },
    {
        "Bulan": "9",
        "Tahun": 2022,
        "MonthName": "Sep",
        "TitleName" : "Deposito",
        "Nilai": "1614709105431.00",
        "Grup": 1
    },
    {
        "Bulan": "10",
        "Tahun": 2022,
        "MonthName": "Oct",
        "TitleName" : "Deposito",
        "Nilai": "2405701216584.00",
        "Grup": 1
    },
    {
        "Bulan": "11",
        "Tahun": 2022,
        "MonthName": "Nov",
        "TitleName" : "Deposito",
        "Nilai": "1749213422331.00",
        "Grup": 1
    },
    {
        "Bulan": "12",
        "Tahun": 2022,
        "MonthName": "Dec",
        "TitleName" : "Deposito",
        "Nilai": "2231076373409.00",
        "Grup": 1
    },
]